import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
} from '@wix/tpa-settings';

import { DIVIDER_TYPE } from '../../../../constants';

export type BackgroundAndBordersStylesParams = {
  appBackgroundColor: StyleParamType.Color;
  menuDividerType: StyleParamType.Number;
  menuDividerWidth: StyleParamType.Number;
  menuDividerColor: StyleParamType.Color;

  itemBorderColor: StyleParamType.Color;
  itemBorderWidth: StyleParamType.Number;

  itemCornerRadiusTopLeft: StyleParamType.Number;
  itemCornerRadiusTopRight: StyleParamType.Number;
  itemCornerRadiusBottomLeft: StyleParamType.Number;
  itemCornerRadiusBottomRight: StyleParamType.Number;
  itemCornerRadiusLinked: StyleParamType.Number;
};

export const backgroundAndBordersStylesParams =
  createStylesParams<BackgroundAndBordersStylesParams>({
    appBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1', 1),
    },
    menuDividerType: {
      type: StyleParamType.Number,
      getDefaultValue: () => DIVIDER_TYPE.SOLID,
    },
    menuDividerWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
    menuDividerColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 0.3),
    },

    itemBorderColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 0.3),
    },
    itemBorderWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },

    itemCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    itemCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    itemCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    itemCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
    itemCornerRadiusLinked: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
    },
  });
